import styled from 'styled-components';

export const HomeImageContainer = styled.img`
  width: 100%;
  max-width: 860px;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 40px;
  width: 80%;
  margin: 0 auto;
  flex-direction: row;
  justify-content: space-around;
  @media all and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 411px) {
    grid-template-columns: 1fr;
  }
`;

export const Projects = styled(Wrapper)`
  grid-template-columns: 115px 115px 115px;
  @media all and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 411px) {
    grid-template-columns: 1fr;
  }
`;

export const InspirationWrapper = styled(Wrapper)`
  @media only screen and (max-width: 700px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 450px) {
    grid-template-columns: 1fr;
  }
`;

export const ProjectsWrapper = styled.div`
  width: 115px;
  margin: 0 auto;
`;

export const ProjectsWrapperWider = styled.div`
  width: 180px;
  margin: 0 auto;
`;

export const ProjectsImage = styled.img`
  width: 100%;
`;
export const ProjectsTitle = styled.span`
  display: block;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-align: center;
`;

export const HulpiaArchitecten = styled.div`
  margin-bottom: 20px;
  @media only screen and (max-width: 600px) {
    float: left;
    width: 100%;
  }
`;

export const HulpiaTitle = styled.div`
  text-align: right;
  letter-spacing: 1em;
  font-size: 1.1rem;
  @media only screen and (max-width: 600px) {
    text-align: left;
  }
`;

export const HulpiaSubTitle = styled.div`
  text-align: right;
  font-size: 0.8rem;
  margin-right: 10px;
  letter-spacing: 0.63em;
  @media only screen and (max-width: 600px) {
    text-align: left;
  }
`;

export const ProjectWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
`;
export const ProjectImage = styled.img`
  display: block;
  max-width: 500px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 20px;
`;

export const SplitSection = styled.section`
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 600px) {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
`;

export const LeftSection = styled.section`
  text-align: right;
  width: 50%;
  @media only screen and (max-width: 600px) {
    width: 100%;
    text-align: left;
  }
`;

export const RightSection = styled.section`
  position: relative;
  padding-left: 15px;
  border-left: 1px solid #000;
  width: 50%;
  font-size: 0.8rem;
  min-height: 400px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    border: 0;
    padding: 20px 0 0 0;
  }
`;

export const SplitSectionPublication = styled(SplitSection)`
  @media only screen and (max-width: 600px) {
    display: flex;
    justify-content: center;
  }
`;

export const LeftSectionPublication = styled(LeftSection)`
  @media only screen and (max-width: 600px) {
    text-align: right;
    width: 50%;
  }
`;

export const RightSectionPublication = styled(RightSection)`
  min-height: 180px;
  @media only screen and (max-width: 600px) {
    width: 50%;
    border-left: 1px solid #000;
    padding-left: 15px;
    box-sizing: border-box;
  }
`;

export const TeamImage = styled.img`
  width: 80%;
  padding-right: 15px;
`;

export const PublicationImage = styled.img`
  height: 95px;
  padding-right: 15px;
`;

export const TeamList = styled.ul`
  margin: 0;
  margin-bottom: 30px;
  list-style-type: none;
  padding: 0;
  line-height: 1.3;
`;

export const TeamListItem = styled.li`
  font-size: 0.9rem;
  font-weight: bolder;
`;

export const Email = styled.a`
  color: #000;
`;

export const Phone = styled.a`
  color: #000;
  text-decoration: none;
`;

export const TeamListItemGrey = styled(TeamListItem)`
  font-weight: normal;
`;

export const Address = styled.div`
  font-size: 0.9rem;
  margin-bottom: 15px;
`;

export const SocialIcons = styled.div`
  position: absolute;
  bottom: 0;
  @media only screen and (max-width: 600px) {
    position: relative;
  }
`;

export const Icon = styled.img`
  display: block;
  width: 20px;
  margin-top: 5px;
`;

export const PublicationYear = styled.h2`
  position: relative;
  text-align: center;
  left: -50px;
  fontsize: 1.2rem;
  letterspacing: 0.5em;
`;

export const PublicationLink = styled.div`
  text-decoration: underline;
  font-size: 0.8rem;
  position: absolute;
  bottom: 85px;
  cursor: pointer;
`;

export const PublicationExternalLink = styled.a`
  color: #000;
  text-decoration: underline;
  font-size: 0.8rem;
  position: absolute;
  bottom: 105px;
  cursor: pointer;
`;

export const PdfViewer = styled.object`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 0.8rem;
  margin-bottom: 5px;
`;

export const SubTitle = styled.div`
  font-size: 0.8rem;
`;

export const ButtonModal = styled.button`
  font-family: ISOCPEUR;
  border: none;
  position: fixed;
  cursor: pointer;
  right: 10px;
  top: 10px;
`;

export const ListItem = styled.li`
  font-size: 0.85rem;
  margin-left: 40px;
  display: inline;
`;

export const ListItemLeft = styled.li`
  font-size: 0.85rem;
  margin-right: 40px;
  display: inline;
`;

export const ModalWindow = styled.div`
  position: fixed;
  top: 10px;
  right: 10px;
  bottom: 10px;
  left: 10px;
  -webkit-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
`;



// WEBPACK FOOTER //
// ./src/static/styles/styles.js